export default __webpack_public_path__ + "static/media/Candle.7a3bdef7.svg";